import { ProductDetailsModal } from "../../../../../interfaces/ProductObject";

// Derives the display price string for any listing type.
// For rentals, picks the lowest filled tier; for others uses sellingPrice.
export function getDisplayPrice(product: ProductDetailsModal | undefined): string {
  if (!product) return "";

  const details = product.details as Record<string, any> | undefined;
  const listingType = (product.listingType ?? "").toLowerCase();

  if (listingType === "rental" || listingType === "rentals") {
    const tiers = [
      { key: "rental_per_hour", label: "/hr" },
      { key: "rental_per_day", label: "/day" },
      { key: "rental_per_week", label: "/week" },
      { key: "rental_per_month", label: "/month" },
    ];
    for (const tier of tiers) {
      const val = details?.[tier.key];
      if (val != null && val !== "") {
        return `₹${val}${tier.label}`;
      }
    }
  }

  if (product.sellingPrice != null) {
    return `₹${product.sellingPrice}`;
  }

  return "";
}

// Maps condition config values (like_new, good, fair, poor) to display labels.
export function formatConditionLabel(condition: string | undefined): string {
  if (!condition) return "";
  const map: Record<string, string> = {
    like_new: "Like New",
    good: "Good",
    fair: "Fair",
    poor: "Poor",
  };
  return map[condition] ?? condition;
}

// Returns a CSS modifier class suffix for the current listing type,
// allowing listing-type-specific style overrides via BEM modifiers.
export function getListingTypeModifier(listingTypeLabel: string | undefined): string {
  if (!listingTypeLabel) return "default";
  const normalized = listingTypeLabel.toLowerCase().replace(/\s+/g, "-");
  const modifierMap: Record<string, string> = {
    "used-product": "used",
    "new-product": "new",
    "menu-item": "menu",
    "menu": "menu",
    "rental": "rental",
    "rentals": "rental",
  };
  return modifierMap[normalized] ?? "default";
}

// Formats a distance string for display.
export function formatDistance(searchDistance: number | undefined): string {
  if (searchDistance == null) return "";
  if (searchDistance < 1) return `${Math.round(searchDistance * 1000)}m away`;
  return `${searchDistance.toFixed(1)}km away`;
}

// Derives the listing badge label from the listingType value.
export function getBadgeLabel(listingType: string | undefined): string {
  if (!listingType) return "";
  const map: Record<string, string> = {
    "Used Product": "Used",
    "New Product": "New",
    "Menu Item": "Menu",
    "Menu": "Menu",
    "Rental": "Rental",
    "Rentals": "Rental",
  };
  return map[listingType] ?? listingType;
}
